import { axios } from './client/axios';
import { setupCommonInterceptors } from './client/interceptors';

/**
 * Function that runs *once* when the app is starting.
 */
export function initApp() {
  setupCommonInterceptors(axios);
}
